import {
  PersonalizeToneOption,
  TONE_OPTIONS,
} from "features/Influencer/QuickSendIndividualDrawer/Dialogs/PersonalizeDialog/schema";

export const BRIEF_TONE_OPTIONS = TONE_OPTIONS.filter(
  (t) =>
    t.id !== PersonalizeToneOption.makeShorter &&
    t.id !== PersonalizeToneOption.addDetail,
);

// Shared between the upfront brief and the Personalize-This-Draft dialog.
export const AI_INCLUDE_OPTIONS = [
  "Reference their Instagram page",
  "Reference a specific product",
  "Mention my past case study",
  "Provide a content idea relevant for the brand",
  "Talk about how my audience aligns with the brand's target",
];

export interface PersonalizationBrief {
  startingTemplateId?: number | null;
  emphasis: string[];
  tone?: PersonalizeToneOption | null;
  notes?: string;
}
